<template>
  <v-bottom-nav fixed style="bottom: 56px;" v-if="isTabletOrMobileView">
    <v-btn :to="rootUrl">
      <span>Home</span>
      <v-icon>home</v-icon>
    </v-btn>

    <v-btn :to="adminUrl" v-if="isAdmin">
      <span>Admin</span>
      <v-icon>settings</v-icon>
    </v-btn>
  </v-bottom-nav>
</template>

<script>
export default {
  props: {
    user: {
      required: true,
      validator: prop => typeof prop === "object" || prop === null
    },
    viewWidth: {
      type: Number,
      required: true
    }
  },
  computed: {
    isAdmin() {
      return this.user ? this.user.isAdmin : false;
    },
    rootUrl() {
      return this.getUrl("home");
    },
    adminUrl() {
      return this.getUrl("departments");
    },
    isTabletOrMobileView() {
      return this.viewWidth <= 960;
    }
  },
  methods: {
    getUrl(routeName) {
      let routeObject = this.$router.resolve({
        name: routeName
      });
      return routeObject.href;
    }
  }
};
</script>
